import { $body } from '../settings/settings';

const isIE = document.body.style.msTouchAction !== undefined;
const isSafari = /constructor/i.test(window.HTMLElement);
const isChrome = !!window.chrome && !!window.chrome.webstore;

const initBrowserClass = () => {
  switch (true) {
    case isIE:
      $body.classList.add('is-ie');
      break;
    case isSafari:
      $body.classList.add('is-safari');
      break;
    case isChrome:
      $body.classList.add('is-chrome');
      break;
    default:
      break;
  }
};

export { isIE, isSafari, isChrome };
export default initBrowserClass;
